/**
 * components/locks/ConnectorJoist.tsx — Lock JOIST side (PLAN §2.18, T14).
 *
 * Presentation MUTO component: Get the side's `ConnectorInstance`
 * joist ALREADY resolved by `model/` (kinetic chain frame → position +
 * quaternion world extracts; meshQuaternion for the GLB) and renders it on the
 * parent group.
 *
 * STEP 6 Δshift (notchShift) is NOT applied here: it is made up of
 * LockScene (render layer) and passed as `position` override — the component
 * remains MUTE (SPEC §6, AC-7).
 *
 * The body (GLB with euler or module parametric fallback box) is delegated to
 * `ConnectorMesh`; here ONLY the transform from the model is applied.*/

import type { Vec3 } from "../../data/types";
import type { ConnectorInstance } from "../../model/types";
import { ConnectorMesh } from "./ConnectorMesh";

// ─── Props (PLAN §2.18) ───────────────────────────────────────

export interface ConnectorJoistProps {
  /** Istanza joist GIÀ posizionata (frame + position + quaternion finali). */
  instance: ConnectorInstance;
  /** Position override (render layer: position + Δshift STEP 6 + explode).*/
  position?: Vec3;
  /** Joist lock color (from config/colors.ts).*/
  color: string;
  /** Show debug helpers (fallback box edges).*/
  showDebug?: boolean;
  /** Material opacity (0..1) — overlay componentsState.*/
  opacity?: number;
  /** Group visibility (overlay componentsState).*/
  visible?: boolean;
}

//─── Component ─────────────────────── ────────────────────────

/**
 * Render the joist side lock. The transform comes from the model:
 * position = instance.position (or override), quaternion = instance.quaternion.*/
export function ConnectorJoist({
  instance,
  position,
  color,
  showDebug = false,
  opacity = 1,
  visible = true,
}: ConnectorJoistProps) {
  const pos = position ?? instance.position;
  return (
    <group position={pos} quaternion={instance.quaternion} visible={visible}>
      <ConnectorMesh
        glbUrl={instance.glbUrl}
        module={instance.module}
        color={color}
        showEdges={showDebug}
        opacity={opacity}
        meshQuaternion={instance.meshQuaternion}
      />
    </group>
  );
}
